import { THEME_STORAGE_KEY } from './theme';

const STORAGE_KEYS = {
  TOKEN: 'auth_token',
  USER: 'user_data',
  REFRESH_TOKEN: 'refresh_token',
  COACH_WELCOME_MODAL: 'coachWelcomeModalSeen',
};

const KEEP_ON_LOGOUT = [STORAGE_KEYS.COACH_WELCOME_MODAL, THEME_STORAGE_KEY];

class StorageManager {
  setToken(token) {
    try {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    } catch (error) {
      console.error('Error saving token:', error);
    }
  }

  getToken() {
    try {
      return localStorage.getItem(STORAGE_KEYS.TOKEN);
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  }

  removeToken() {
    try {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
    } catch (error) {
      console.error('Error removing token:', error);
    }
  }

  setRefreshToken(token) {
    try {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
    } catch (error) {
      console.error('Error saving refresh token:', error);
    }
  }

  getRefreshToken() {
    try {
      return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch (error) {
      console.error('Error getting refresh token:', error);
      return null;
    }
  }

  removeRefreshToken() {
    try {
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch (error) {
      console.error('Error removing refresh token:', error);
    }
  }

  setUser(user) {
    try {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    } catch (error) {
      console.error('Error saving user:', error);
    }
  }

  getUser() {
    try {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error getting user:', error);
      return null;
    }
  }

  removeUser() {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
    } catch (error) {
      console.error('Error removing user:', error);
    }
  }

  // Wipes everything on logout except device preferences that should outlive a
  // session: the coach's "Do not show again" welcome choice and light/dark theme.
  clearAll() {
    try {
      const kept = KEEP_ON_LOGOUT.map((key) => [key, localStorage.getItem(key)]);
      localStorage.clear();
      kept.forEach(([key, value]) => {
        if (value !== null) localStorage.setItem(key, value);
      });
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  }
}

export default new StorageManager();
